import { type ThemeConfig } from "@/lib/antd";

export type TypeThemeConfigColors = {
  primary: string;
  secondary: string;
  success: string;
  processing: string;
  error: string;
  background: string;
  secondaryBackground: string;
  layoutBackground: string;
  transparent: string;
  siderBg: string;
  primaryText: string;
  secondaryText: string;
  cardBackgroundColor: string;
  borderColor: string;
  secondaryBorderColor: string;
  textDisabled: string;
  conversationOutputBg: string;
  conversationFileViewBg: string;
  conversationInputBg: string;
  hyperLinkColor: string;
  nodeCompleted: string;
  nodeWaitingForApproval: string;
  nodeApproved: string;
  quaternaryText: string;
  chatInputBackground: string;
  primaryLight: string;
  primaryDark: string;
  menuItemHoverBG: string;
  menuItemSelectedBG: string;
  nodeBorderColor: string;
  workflowBackground: string;
  backgroundNode: string;
  edgeColor: string;
  menuColor:string;
};
export const lightThemeConfigColors = {
  // primary: "#6B22BE",
  primary: "#00A5A8",
  primaryLight: "#f9f0ff",
  primaryDark: "#400086",
  secondary: "#00A5A8",
  success: "#52c41a",
  processing: "#1677ff",
  error: "#C83333",
  layoutBackground: "#f6f7f9",
  background: "#F2F2F2",
  backgroundAccentColor: "#e6e6e6",
  secondaryBackground: "#EFEEE5",
  transparent: "transparent",
  siderBg: "#EFEEE5",
  primaryText: "#080808",
  secondaryText: "#393939",
  quaternaryText: "rgba(0, 0, 0, 0.25)",
  cardBackgroundColor: "#ffffff",
  borderColor: "#d9d9d9",
  secondaryBorderColor: "#f0f0f0",
  textDisabled: "#CCCCCC",
  conversationOutputBg: "#f6f7f9",
  conversationFileViewBg: "#0A1B1C",
  conversationInputBg: "#FAFAFA",
  hyperLinkColor: "#00A5A8",
  nodeCompleted: "#DDF3E6",
  nodeWaitingForApproval: "#FFF4B5",
  nodeApproved: "#C4D7FF",
  bgError: "#fff2f0",
  borderError: "#ffe8e6",
  colorInfo: "#1677ff",
  colorInfoBg: "#e6f4ff",
  colorInfoBorder: "#91caff",
  colorSuccessBg: "#f6ffed",
  colorSuccessBorder: "#b7eb8f",
  colorWarning: "#faad14",
  colorWarningBg: "#fffbe6",
  colorWarningBorder: "#ffe58f",
  menuItemHoverBG: "#d9f2f2",
  menuItemSelectedBG: "#b2e0e0",
  chatInputBackground: "#fafafa",
  nodeBorderColor: "#393939",
  workflowBackground: "#FAFAFA",
  backgroundNode: "#FFFFFF",
  edgeColor: "#CECECE",
  menuColor:"#F6F5F0"
};

export const darkThemeConfigColors = {
  // primary: "#6B22BE",

  primaryLight: "#2d7f82",
  primaryDark: "#104e51",
  secondary: "#1b7a7d",

  "primary-75": "#1a7073",
  "primary-50": "#15595b",
  "primary-25": "#0e3f41",
  "primary-10": "#071f20",

  "primary-200": "#4c9295",
  "primary-300": "#72abad",
  "primary-400": "#a0c9cb",
  "primary-500": "#cfe7e8",
  primary: "#32EBEE",

  success: "#4CAF50",
  processing: "#62B6FF",
  layoutBackground: "#2a2a2a", // Dark with slight depth
  background: "#161618", // Nearly black with subtle undertone
  backgroundAccentColor: "#3a3a3a", // greyer than #2a2a2a
  secondaryBackground: "#2a2a2a", // lifted from #0D0D0D to soften
  cardBackgroundColor: "#333333",
  transparent: "transparent",
  siderBg: "#141415", // Deepest black with subtle undertone// Deep navy blue-grey
  primaryText: "#FFFFFF",
  secondaryText: "#B3B3B3",
  quaternaryText: "#393939",
  borderColor: "#262626",
  secondaryBorderColor: "#3A3A3A",
  textDisabled: "#666666",
  conversationOutputBg: "#1E1F20",
  conversationFileViewBg: "#0A1B1C",
  conversationInputBg: "#1E1E1E",
  hyperLinkColor: "#32EBEE",
  nodeCompleted: "#2A3B2F",
  nodeWaitingForApproval: "#554C2A",
  nodeApproved: "#2A3B55",

  error: "#FF6B6B",

  bgError: "#5a3f3e", // softened from #4d3836
  borderError: "#4a3433", // slightly greyer than #3d2e2d

  colorInfo: "#5ecaff",
  colorInfoBg: "#14344a", // lifted from #002b48
  colorInfoBorder: "#28507a", // more neutral than #17406d

  colorSuccess: "#52c41a",
  colorSuccessBg: "#1c2f1a", // lifted from #132a13
  colorSuccessBorder: "#2e5d2c", // more balanced than #1c561e

  colorWarning: "#faad14",
  colorWarningBg: "#4a3505", // lighter and greyer than #402c00
  colorWarningBorder: "#6a5200", // lifted from #614700

  menuItemHoverBG: "#0b3232",
  menuItemSelectedBG: "#005354",
  chatInputBackground: "#1E1E1E",
  nodeBorderColor: "#4A4A4A",
  workflowBackground: "#181818",
  backgroundNode: "#080808",
  edgeColor: "#4A4A4A",
    menuColor:"#0A0A0F"

};

export const themeConfigColors = {
  primary: "#6B22BE",
  secondary: "#5502B4",
  success: "#52c41a",
  processing: "#1677ff",
  error: "#C83333",
  background: "#F2F2F2",
  transparent: "transparent",
  siderBg: "#080808",
  primaryText: "#080808",
  secondaryText: "#393939",
};
